import axios from "axios";

export default class InformacionService {
  allDocuments() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "info/all");
  }
  downloadFile(url) {
    return axios.get(url, { responseType: 'blob' });
  }
  allDocumentsForAdmin() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "info/allforadmin");
  }
  crearInformacion(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "info/create", data);
  }
  editarInformacion(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "info/update", data);
  }
  eliminarInformacion(data) {
    return axios.delete(process.env.VUE_APP_API_PUBLIC + "info/delete", {
      data: data,
    });
  }
  eliminarIcon(data) {
    return axios.delete(process.env.VUE_APP_API_PUBLIC + "info/delete-icon", {
      data: data,
    });
  }
}
